/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate , useSearchParams} from 'react-router-dom'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {login} from '../redux/AuthCRUD'
import {AUTH_TOKEN_COOKIE_KEY} from '../../../constants'
import Cookies from 'js-cookie'
import * as accountRedux from '../../../store/account'
import {FleksupService} from '../../../services/FleksupService'
import ReCAPTCHA from 'react-google-recaptcha'
import Swal from 'sweetalert2'


const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Geçerli bir e-posta adresi giriniz.')
    .min(3, 'En az 3 karakter içermelidir.')
    .max(50, 'En fazla 50 karakter içerebilir')
    .required('E-pota adı zorunludur.'),
  password: Yup.string()
    .min(3, 'En az 3 karakter içermelidir.')
    .max(50, 'En fazla 50 karakter içerebilir')
    .required('Şifre zorunludur.'),
 // recaptcha: Yup.string().required('Doğrulama hatalı'),
})

const initialValues = {
  email: '',
  password: '',
  recaptcha: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {

  let navigate = useNavigate()
  let [searchParams] = useSearchParams()
  const request_type: any = searchParams.get('request_type')
  const error_code: any = searchParams.get('error_code')
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        login(values.email, values.password)
          .then((loginRes) => {
            setLoading(false)
            Cookies.set(AUTH_TOKEN_COOKIE_KEY, loginRes.data?.token)
            FleksupService.getAccount().then((res) => {
              dispatch(accountRedux.actions.setAccount(res.data.data))
              dispatch(auth.actions.login(loginRes.data))
            })
          })
          .catch(() => {
            setLoading(false)
            setSubmitting(false)
            setStatus('Kullanıcı adı veya şifre yanlış.')
          })
      }, 1000)
    },
  })

  useEffect(() => {

if (request_type !== null && request_type.length > 0 && request_type ==='ideasoft'){

  const ideasoftErrorMessages:any = {
    "undefined_package_type_request":"Satın alınan ideasoft paketi tanımlanamadı.",
    "create_company_failure":"İdeasoft firma kaydınızın oluşturulma sürecinde hata oluştu.",
    "create_user_failure":"ideasoft kullanıcı kaydınızın oluşturulmasında hata oluştu.",
    "get_license_failure":"ideasoft lisans tanımlarında hata oluştu.",
    "system_exception":"Sistem hatası oluştu.",
    "user_not_found":"Kullanıcı kaydı bulunamadı."
  };
  const errorMessage = `İdeasoft uygulama yükleme işlemi başarısız! <br><br>Lütfen destek@fleksup.com eposta adresi üzerinden fleksup yönetim ile iletişime geçiniz.`

  Swal.fire({
    html: errorMessage,
    title: ideasoftErrorMessages[error_code],
    icon: 'error',
    buttonsStyling: false,
    confirmButtonText: 'Kapat',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
  })

}


  },[navigate, request_type, error_code]);



  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Fleksup Giriş</h1>
        <div className='text-gray-400 fw-bold fs-4'>
          Burada yeni misin?{' '}
          <Link to='/account/registration' className='link-primary fw-bolder'>
            Kayıt ol
          </Link>
        </div>
      </div>
      {/* begin::Heading */}
      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      <div className='fv-row mb-10'>
        <label className='form-label fw-bolder text-dark fs-6'>E-Posta</label>
        <input
          placeholder='E-Posta'
          type='email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Şifre</label>
            {/* end::Label */}
          </div>
        </div>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      <ReCAPTCHA
        sitekey='6LfpV2UhAAAAAPwWfTu57F4nbsT-z_mSB_uUGGhX'
        onChange={() => formik.setFieldValue('recaptcha', 'Doğrulandı.')}
        hl={'tr'}
      />
      {formik.touched.recaptcha && formik.errors.recaptcha && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors.recaptcha}</span>
          </div>
        </div>
      )}
      ,{/* end::Form group */}
      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Giriş Yap</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Lütfen Bekleyin...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      <div className='d-flex justify-content-center'>
        <Link
          to='/account/forgot-password'
          className='link-primary fs-6 fw-bolder mb-5'
          style={{marginLeft: '5px'}}
        >
          Şifreni mi unuttun?
        </Link>
      </div>
      {/* end::Action */}
    </form>
  )
}
